/**
 * Asynchronously loads the component for SigninPage
 */

import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "Signin" */ './index'), {
  fallback: <LoadingPage delay={1} />
})
